var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Organization_1;
import { Literal } from 'lincd/models';
import { linkedShape } from '../package.js';
import { Person } from './Person.js';
import { schema } from '../ontologies/schema.js';
import { literalProperty, objectProperty } from 'lincd/shapes/SHACL';
import { Thing } from './Thing.js';
import { ShapeSet } from 'lincd/collections/ShapeSet';
import { xsd } from 'lincd-xsd/ontologies/xsd';
let Organization = Organization_1 = class Organization extends Thing {
    get faxNumber() {
        return this.getValue(schema.faxNumber);
    }
    set faxNumber(val) {
        this.overwrite(schema.faxNumber, new Literal(val));
    }
    get email() {
        return this.getValue(schema.email);
    }
    set email(val) {
        this.overwrite(schema.email, new Literal(val));
    }
    get legalName() {
        return this.getValue(schema.legalName);
    }
    set legalName(val) {
        this.overwrite(schema.legalName, new Literal(val));
    }
    get address() {
        return this.getValue(schema.address);
    }
    set address(val) {
        this.overwrite(schema.address, new Literal(val));
    }
    get telephone() {
        return this.getValue(schema.telephone);
    }
    set telephone(val) {
        this.overwrite(schema.telephone, new Literal(val));
    }
    static getAffiliationsOf(person) {
        return person.getAllAs(schema.affiliation, Organization_1);
    }
    static setAffiliation(person, org) {
        person.set(schema.affiliation, org.namedNode);
    }
    get members() {
        return Person.getSetOf(this.getAll(schema.members));
    }
    get founder() {
        return this.getOneAs(schema.founder, Person);
    }
    set founder(val) {
        this.overwrite(schema.founder, val ? val.node : null);
    }
};
Organization.targetClass = schema.Organization;
__decorate([
    literalProperty({
        path: schema.faxNumber,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "faxNumber", null);
__decorate([
    literalProperty({
        path: schema.email,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "email", null);
__decorate([
    literalProperty({
        path: schema.legalName,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "legalName", null);
__decorate([
    literalProperty({
        path: schema.address,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "address", null);
__decorate([
    literalProperty({
        path: schema.telephone,
        maxCount: 1,
        datatype: xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "telephone", null);
__decorate([
    objectProperty({
        path: schema.members,
        shape: Person,
    }),
    __metadata("design:type", ShapeSet),
    __metadata("design:paramtypes", [])
], Organization.prototype, "members", null);
__decorate([
    objectProperty({
        path: schema.founder,
        shape: Person,
        maxCount: 1,
    }),
    __metadata("design:type", Person),
    __metadata("design:paramtypes", [Person])
], Organization.prototype, "founder", null);
Organization = Organization_1 = __decorate([
    linkedShape({
        description: 'An organization such as a school, NGO, corporation, club, etc.; has members, leaders, and contact info. Links to Person and Address. (org, company, group, institution)',
    })
], Organization);
export { Organization };
//# sourceMappingURL=Organization.js.map